<template>
  <div class="content">
    <iframe
      width="100%"
      frameborder="0"
      height="505"
      :src="target+':'+blastPort+'/'"
    ></iframe>
  </div>
</template>
<script>
import axios from "axios";
var path = require('path');
var proEnv = require('../../../config/pro.env');//生产环境
var uatEnv = require('../../../config/uat.env');//测试环境
var devEnv = require('../../../config/dev.env');//本地环境
export default {
  data() {
    return {
      id: "",
      targetLocation: "http://47.97.5.38:1047/",
      blastDatas: null,
      blastPort:"",
      target:''
    };
  },
  created() {
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
     const env = process.env.NODE_ENV;
    let target = '';
    //默认是本地环境
    if (env === 'production') {//生产环境
      target = proEnv.blasturl;
    } else if (env === 'test') {//测试环境
      target = uatEnv.blasturl;
    } else {//本地环境
      target = devEnv.blasturl;
    }

    this.target=target;
    //console.log(this.$route.query.id);
    let id = this.$route.query.id;
    let blastPort = this.$route.query.blastPort;
    if (id == "" || blastPort == '') {
    } else {
      this.id = id;
      this.blastPort=blastPort;
      this.getBlastinfo(id);
    }
  },
  mounted() {
    if (this.$route.query.id) {
      let url=(this.target+':'+this.blastPort+'/');
      //console.log(url);
      var blastDatas = JSON.parse(localStorage.getItem("blastData"));
      setTimeout(function () {
        //console.log(blastDatas);
        window.frames[0].postMessage(blastDatas,url);
      }, 2000);
    }
  },
  methods: {
    getBlastinfo(id) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/gene/blastInfo/" + id,{
          headers: { Authorization: token},
        })
        .then(function (response) {
          //console.log(response);
          let data = response.data;
          let databaseObject = response.data.databaseObject;
          let arr = [];
          for (let i = 0; i < databaseObject.length; i++) {
            if (databaseObject[i] != "" && databaseObject != null) {
              arr.push(databaseObject[i]);
            }
          }
          //console.log(arr);
          let sequence = response.data.sequenceObject.sequence;
          let blastData = {
            sequence: sequence,
            databases: arr,
          };
          localStorage.setItem("blastData", JSON.stringify(blastData));
        })
        .catch(function (error) {
          //that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.content {
  width: 1200px;
  /* height: 580px; */
  margin: 0 auto;
}
</style>